import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "toggleButton"]

  toggle() {
    const input = this.inputTarget
    const button = this.toggleButtonTarget.querySelector('i')
    
    const isPassword = input.type === 'password'
    input.type = isPassword ? 'text' : 'password'

    if (isPassword) {
      button.classList.remove('zmdi-eye-off')
      button.classList.add('zmdi-eye')
    } else {
      button.classList.remove('zmdi-eye')
      button.classList.add('zmdi-eye-off')
    }
  }
} 